<div id="layout-wrapper">
  <!-- Top Bar -->
  <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()" (settingsButtonClicked)="onSettingsButtonClicked()">
  </app-topbar>
  <!-- Side Bar -->
  <app-sidebar (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-sidebar>
  <div class="main-content">
    <div class="page-content">
      <div class="container-fluid">
        <!-- Main Content -->
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- Footer -->
    <app-footer></app-footer>
  </div>
</div>
<!-- Right Side Bar -->
<app-rightsidebar></app-rightsidebar>
